import React from "react";
import { Form } from "react-bootstrap";
import CopyIcon from "./CopyIcon";

interface CopyableInputProps
  extends Omit<React.ComponentPropsWithoutRef<"input">, "size"> {
  value?: string;
  name?: string;
  id?: string;
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  size?: "sm" | "lg";
  isInvalid?: boolean;
  isValid?: boolean;
  className?: string;
}

const CopyableInput: React.FC<CopyableInputProps> = ({ 
  value, 
  name, 
  id, 
  placeholder, 
  onChange, 
  type = "text", 
  size = "sm", 
  isInvalid = false,
  isValid = false,
  className = "",
  ...props 
}) => {
  return (
    <div className={`d-flex align-items-center gap-2 ${className}`}>
      <Form.Control
        type={type}
        name={name}
        id={id}
        placeholder={placeholder}
        value={value || ""}
        onChange={onChange}
        isInvalid={isInvalid}
        isValid={isValid}
        size={size}
        {...props}
      />
      {value && <CopyIcon text={value} />}
    </div>
  );
};

export default CopyableInput;
